import {h, Fragment} from "preact"
export default function Checkbox({ value, selected, onChange, className }) {
    return (
        <label className={`ns-checkbox ns-d-block ns-color-black ns-swatch-${value.toLowerCase().replaceAll(" ", "-")} ${className}`}>
            {value}
            <input type="checkbox" checked={selected} onChange={onChange} />
            <span className="ns-checkmark" style={`background-color: ${value.toLowerCase().replaceAll(" ", "-")}`} />
        </label>
    )
}